import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { BravadoButtonV3Size } from '~/components/common/BravadoButtonV3/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioJobsInquirySectionEmpty',
  setup(__props) {

const route = useRoute();

function redirectToOnboarding() {
  window.location.href = `/b2c/?${new URLSearchParams(route.value.query as {}).toString()}`;
}

return { __sfc: true,route, redirectToOnboarding, BravadoButtonV3, BravadoButtonV3Size }
}

})